module.exports = __webpack_public_path__ + "static/assets/00b52ebc5d6bb7b522bfc7f47e095156.png";